import { compose } from 'recompose';

import TimeZoneView from './TimeZoneView';

export default compose()(TimeZoneView);
